// extracted by mini-css-extract-plugin
export var closeButton = "_qj-2";
export var closeButtonIcon = "_qj-3";
export var lightboxContent = "_qj-1";
export var lightboxOverlay = "_qj-0";